import template from './entityContactDetails.html';
import EntityContactDetailsCtrl from './entityContactDetailsCtrl';

export default {
  template,
  controller: EntityContactDetailsCtrl,
  controllerAs: 'vm',
  bindings: {
    partyType: '<',
    entityData: '=',
    formReference: '<',
  },
};
